
import React, { useEffect } from 'react';
import { motion } from "framer-motion";
import { BusinessSeo, ServicesSeo } from '../../utils/Seo';
import HeaderSeo from '../../components/HeaderSeo/Headerseo';
import Newnavigation from '../../components/new-navigation/new_navigation';
import ContactNew from '../../components/contact-form/ContactNew';
import Footer from '../../components/footer/Footer';
import {  BUSINESS_bg } from '../../assets/images';
import {  BusinessServicesBanner } from '../../utils/servicebanner';
import AboutusBanner from '../../components/Aboutus-banner/AboutusBanner';
import ServiceSteps from '../../components/service-steps/ServiceSteps';
import { BusinessOurMissons, BusinesskeyService, Businessstepsdata } from '../../utils/services';
import OurMissions from '../../components/Our-missions/OurMissions';
import ServicesKey from '../../components/services-key/ServicesKey';

const BusinessTransformation = () => {
    useEffect(() => {
        window.scroll({
          top: 0,
          behavior: "smooth",
        });
      }, []);
      return (
        <motion.div initial={{ opacity: 0 }}animate={{ opacity: 1, transition: { duration: 1 } }}>
        <div className='service-page '>
            <HeaderSeo data={BusinessSeo}/>
            <Newnavigation routeName="services"/>
            <AboutusBanner bg={BUSINESS_bg} data={BusinessServicesBanner}/>
            <ServiceSteps 
            title="Innovate, Adapt, and Thrive"
            stepsData={Businessstepsdata}
             />
              <OurMissions  data={BusinessOurMissons} />
              <ServicesKey data={BusinesskeyService} />
    
              
            <ContactNew />
            <Footer />
        </div>
        </motion.div>
    )
}

export default BusinessTransformation